import { Col } from "reactstrap";
import { H6, LI, OL } from "../../../../AbstractElements";
import { OrderLists } from "../../../../Constant";

export const OrderList = () => {
  return (
    <Col sm="12" xl="4">
      <div className="card-wrapper border rounded-3 h-100">
        <H6 className="sub-title fw-bold">{OrderLists}</H6>
        <OL className="simple-list list-group-numbered">
          <LI>UI Kits</LI>
          <LI>Bonus Ui</LI>
          <LI>Animations</LI>
          <LI>
            Icon
            <OL className="simple-list list-group-numbered mb-0">
              <LI>Typography</LI>
              <LI>Avatars</LI>
              <LI>Grid</LI>
              <LI>Tag & pills</LI>
              <LI>Alert</LI>
            </OL>
          </LI>
          <LI>Dropdown</LI>
          <LI>Tabs</LI>
          <LI>Accordion</LI>
        </OL>
      </div>
    </Col>
  );
};
